<nav class="navigation">
  <ul class="nav-list">
    @for (route of filteredRoutes; track route.path) {
      <li class="nav-item">
        <a
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLink]="[route.path]"
          class="nav-link {{ route.path }}"
          routerLinkActive="active"
        >
          <art-icon [fontSize]="'40px'" shape="outlined">{{ itemIcons[route.path] }}</art-icon>
        </a>
        <dx-text type="its">
          {{ "navigation.route." + route.path | transloco }}
        </dx-text>
      </li>
    }
  </ul>
</nav>
